<template>
  <div class="charts-wrap">
    <div class="content-title">指标趋势</div>
    <div class="filter-wrap" v-loading="loading">
      <el-select class="top-select" v-model="chartFilter.demission" placeholder="请选择维度" @change="searchData(topFilterData)">
        <el-option v-for="item of dimensionList" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
      <el-select class="top-select multiple-select" v-model="chartFilter.field" placeholder="请选择指标" @change="handleData">
        <el-option v-for="item of fieldList" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
    </div>
    <div class="charts-area" ref="chartRef"></div>
  </div>
</template>

<script>
import { getLineGraph } from "@/api/tools.js";
import { dimensionList, transFilterData } from "./config";
import * as echarts from "echarts";
export default {
  name: "ChartsLine",
  props: {
    topFilterData: Object,
    chartFilter: {
      type: Object,
      default: () => {
        return {
          field: "show_cnt",
          demission: 1,
        };
      },
    },
  },
  data() {
    return {
      myChart: null,
      loading: false,
      allDataList: [],
      fieldList: [
        { label: "曝光", value: "show_cnt" },
        { label: "点击", value: "click_cnt" },
        { label: "点击率", value: "ctr" },
        { label: "激活", value: "active_cnt" },
        { label: "转化率", value: "convert_rate" },
        { label: "消耗", value: "cost" },
        { label: "收入", value: "income" },
        { label: "ROI", value: "roi" },
        { label: "arpu", value: "arpu" },
        // { label: "活跃arpu", value: "5" },
        // { label: "平均ecpi", value: "3" },
        // { label: "活跃收入", value: "4" },
      ],
      dimensionList,
    };
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    searchData(data) {
      const { pkg, platType, advertiserId, campaignId, dateEnd, campaignName, dateStart } = transFilterData(data);
      this.loading = true;
      getLineGraph({
        pkg,
        platType,
        advertiserId,
        campaignId,
        campaignName,
        dateEnd,
        dateStart,
        demission: this.chartFilter.demission,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === "0000") {
            this.allDataList = res.data;
            this.handleData();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleData() {
      let chartsData = this.formatData(this.allDataList);
      this.renderData(chartsData);
    },
    formatData(list) {
      const data = Object.values(list);
      let labelList = Object.keys(list);
      let seriesList = [];
      let dateList = data[0]?.map((item) => item.statDate);
      data.forEach((item, index) => {
        seriesList.push({
          name: labelList[index],
          type: "line",
          data: item.map((item) => item[this.chartFilter.field]),
          smooth: true,
          symbol: "circle",
          symbolSize: 8,
        });
      });
      return {
        labelList,
        dateList,
        seriesList,
      };
    },
    initCharts() {
      let chartDom = this.$refs.chartRef;
      let myChart = echarts.init(chartDom);
      window.onresize = myChart.resize;
      this.myChart = myChart;
    },
    renderData(chartData) {
      let that = this;
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              const value = ["ctr", "convert_rate"].includes(that.chartFilter.field) ? `${params[i].value}%` : params[i].value;
              relVal += "<br/>" + params[i].marker + params[i].seriesName + " : " + value;
            }
            return relVal;
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
          "#00B2EE",
          "#CD00CD",
          "#00ff66",
          "#FA8072",
        ],
        legend: {
          data: chartData.labelList,
          x: "center",
          y: "bottom",
        },
        grid: {
          top: "50px",
          left: "50px",
          right: "50px",
          bottom: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: chartData.dateList,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#A3A3A3",
              fontSize: 13,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
        },
        yAxis: {
          type: "value",
          name: this.fieldList.find((item) => item.value === this.chartFilter.field)?.label,
          nameTextStyle: {
            color: "rgba(0, 0, 0, 0.64)",
          },
          axisLabel: {
            textStyle: {
              color: "#A3A3A3",
              fontSize: 13,
            },
            formatter: function (value) {
              // y轴自定义数据
              return ["ctr", "convert_rate"].includes(that.chartFilter.field) ? `${value}%` : value;
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(240, 240, 240, 1)",
            },
          },
        },
        series: chartData.seriesList,
      };
      this.myChart.clear();
      this.myChart.setOption(option);
    },
  },
  watch: {
    chartFilter: {
      handler(val) {
        this.$emit("update:chartFilter", val);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.charts-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 16px 24px;
  margin-bottom: 16px;
  .content-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 16px;
  }
  .filter-wrap {
    .top-select {
      width: 160px;
      margin-right: 12px;
    }
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .charts-area {
    height: 400px;
  }
}
</style>
